import React from 'react';
import DepartmentProfileSwitcher from './DepartmentProfileSwitcher';
import hasFeature from 'utils/hasFeature';
import {departmentProfiles} from 'utils/const';
import {Link} from 'react-router';
import 'styles/admin/DepartmentProfilesTable.styl';
import {routeOf} from 'components/pure/admin/DepartmentForm';

const departmentProfileTypes = Object.keys(departmentProfiles);
const featureFlag = key => departmentProfiles[key].flag;

export default class DepartmentProfilesTable extends React.PureComponent {
  render() {
    const {flags} = this.props;
    return (
      <table className="department-profiles-table generic-table">
        <thead>
          <tr>
            <th>Name</th>
            {departmentProfileTypes.map((key, i) => {
              return hasFeature(flags, featureFlag(key)) ? (
                <th key={i}>{departmentProfiles[key].label}</th>
              ) : null;
            })}
          </tr>
        </thead>
        <tbody>
          {this.props.departmentProfiles
            .sortBy(department => department.name.toLowerCase())
            .map(department => (
              <tr key={department.id}>
                <td>
                  <Link to={`/admin/departments/edit/${department.id}`} className="generic-link">
                    {department.name}
                  </Link>
                </td>
                {departmentProfileTypes.map(type => {
                  const route = routeOf(flags, department.id, departmentProfiles, type);
                  const propName = departmentProfiles[type].pluralized;
                  return hasFeature(this.props.flags, featureFlag(type)) ? (
                    <td key={type}>
                      <DepartmentProfileSwitcher
                        showConfirmModal={true}
                        updateDepartment={this.props.updateDepartment}
                        department={department}
                        type={type}
                        newProfileRoute={
                          // doesn't handle objects, and we don't have any place to send the user when
                          // it is an object (new topics admin route has no 'new' page).
                          typeof route === 'string' ? route : undefined
                        }
                        options={this.props[propName]}
                        wasError={this.props[propName + 'Error']}
                      />
                    </td>
                  ) : null;
                })}
              </tr>
            ))}
        </tbody>
      </table>
    );
  }
}
